import { featuredArticles, latestList } from "../../../mocks/news";
import { CoverCard } from "../../../components/base/NewsCard";
import SectionTitle from "../../../components/base/SectionTitle";

export default function FeaturedGrid() {
  const rest = latestList.filter((a) => !featuredArticles.some((f) => f.slug === a.slug)).slice(0, 3);
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
      <SectionTitle eyebrow title="深度精选 · 值得细读" to="/about" linkLabel="了解本站定位" />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {featuredArticles.map((item) => (
          <CoverCard key={item.slug} item={item} />
        ))}
      </div>
      {rest.length > 0 && (
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((item) => (
            <CoverCard key={item.slug} item={item} />
          ))}
        </div>
      )}
    </section>
  );
}